module.exports = __webpack_public_path__ + "img/boston.013ec77b.jpg";